import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";

export const ProjectCard = ({
  title,
  description,
  imgUrl,
  live,
  id,
  screenShots,
  client,
  server,
  features,
}) => {
  return (
    <Col size={12} sm={6} md={4}>
      <Link
        className="text-white"
        to={`/details/${id}`}
        state={{
          screenShots: screenShots,
          live: live,
          client: client,
          server: server,
          features: features,
        }}
      >
        <div className="proj-imgbx">
          <img src={imgUrl} alt="" />
          <div className="proj-txtx">
            <h4>
              <a href={`${live}`}>{title}</a>
            </h4>
            <span>{description}</span>
          </div>
        </div>
      </Link>
    </Col>
  );
};
